<template>
  <div class="section section-tabs">
    <div class="container-fluid mb-3">
      <div class="title" style="text-align: center;">
        <h2 style="font-weight: 900; text-decoration: underline;">SOLUCIONES Y ENFOQUES</h2>
        <p class="category">DESARROLLO E INTEGRACIÓN DE PROYECTOS ADAPTADOS A DIVERSOS SECTORES Y NECESIDADES</p>
      </div>
      <div class="row" style="text-align: center;">
        <div class="col-md-3 form-group mx-auto mb-5">
          <img src="@/assets/tableros.png" width="100" height="100" class="mr-1" style="margin-top: -6px">
          <br>
          <a style="font-size: 16px; color: #274f78; font-weight: 900;">INTEGRACIÓN DE TABLEROS ELÉCTRICOS EN MEDIA Y BAJA TENSIÓN</a>
          <br>
          <a style="font-size: 16px; color: #1e293baf;">⫸Distribución eléctrica.</a>
          <br>
          <a style="font-size: 16px; color: #1e293baf;">⫸Control y automatización de procesos.</a>
          <br>
          <a style="font-size: 16px; color: #1e293baf;">⫸Fabricación de tableros.</a>
        </div>
        <div class="col-md-3 form-group mx-auto mb-5">
          <img src="@/assets/proyectos_act.png" width="100" height="100" class="mr-1" style="margin-top: -6px">
          <br>
          <a style="font-size: 16px; color: #274f78; font-weight: 900;">PROYECTOS DE ACTUALIZACIÓN, MEDIA TENSIÓN, BAJA TENSIÓN, (RETRO ADAPTACIONES)</a>
        </div>
        <div class="col-md-3 form-group mx-auto mb-5">
          <img src="@/assets/instalacion_pm.png" width="100" height="100" class="mr-1" style="margin-top: -6px">
          <br>
          <a style="font-size: 16px; color: #274f78; font-weight: 900;">INSTALACIÓN Y PUESTA EN MARCHA EN MEDIA Y BAJA TENSIÓN</a>
        </div>
        <div class="col-md-3 form-group mx-auto mb-5">
          <img src="@/assets/robotica.png" width="100" height="100" class="mr-1" style="margin-top: -6px">
          <br>
          <a style="font-size: 16px; color: #274f78; font-weight: 900;">ROBÓTICA, LLAVE EN MANO</a>
        </div>
      </div>

      <div class="row" style="text-align: center;">
        <div class="col-md-3 form-group mx-auto mb-5">
          <img src="@/assets/mantenimiento.png" width="100" height="100" class="mr-1" style="margin-top: -6px">
          <br>
          <a style="font-size: 16px; color: #274f78; font-weight: 900;">MANTENIMIENTO A ELECTRÓNICA DE POTENCIA (VARIACIÓN DE VELOCIDAD Y SOFTSTART)</a>
        </div><div class="col-md-3 form-group mx-auto mb-5">
          <img src="@/assets/refrigeracion.png" width="100" height="100" class="mr-1" style="margin-top: -6px">
          <br>
          <a style="font-size: 16px; color: #274f78; font-weight: 900;">REFRIGERACIÓN INDUSTRIAL Y COMERCIAL</a><br>
          <a style="font-size: 16px; color: #1e293baf;">⫸Cámaras refrigeradas.</a>
        </div>
        <div class="col-md-3 form-group mx-auto mb-5">
          <img src="@/assets/aire_a.png" width="100" height="100" class="mr-1" style="margin-top: -6px">
          <br>
          <a style="font-size: 16px; color: #274f78; font-weight: 900;">AIRE ACONDICIONADO</a>
          <br>
          <a style="font-size: 16px; color: #1e293baf;">⫸Instalación.</a>
          <br>
          <a style="font-size: 16px; color: #1e293baf;">⫸Mantenimiento.</a>
        </div>
        <div class="col-md-3 form-group mx-auto mb-5">
          <img src="@/assets/estacion_b.png" width="100" height="100" class="mr-1" style="margin-top: -6px">
          <br>
          <a style="font-size: 16px; color: #274f78; font-weight: 900;">ESTACIONES DE BOMBEO</a>
          <br>
          <a style="font-size: 16px; color: #1e293baf;">⫸Instalación.</a>
          <br>
          <a style="font-size: 16px; color: #1e293baf;">⫸Mantenimiento.</a>
        </div>
      </div>

      <div class="row" style="text-align: center;">
        <div class="col-md-3 form-group mx-auto mb-5">
          <img src="@/assets/comercializacion.png" width="100" height="100" class="mr-1" style="margin-top: -6px">
          <br>
          <a style="font-size: 16px; color: #274f78; font-weight: 900;">COMERCIALIZACIÓN DE PRODUCTOS DE ELECTRIFICACIÓN</a>
          <br>
          <a style="font-size: 16px; color: #1e293baf;">⫸De baja tensión.</a>
          <br>
          <a style="font-size: 16px; color: #1e293baf;">⫸Control.</a>
          <br>
          <a style="font-size: 16px; color: #1e293baf;">⫸Automatización.</a>
          <br>
          <a style="font-size: 16px; color: #1e293baf;">⫸Solar.</a>
          <br>
          <a style="font-size: 16px; color: #1e293baf;">⫸Distribución de energía.</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  components: {
  }
};
</script>
<style>
.tab-content.tab-content-padding {
  padding: 20px;
}
</style>
